import axios from 'axios';
import { BaseCoreURL } from '../../config';

import { PAYTM_CITY_SEARCH_DATA } from './actionTypes'

import { PHONETIC_CITY_SEARCH } from '../../config/urls';

export const fetchCities = (searchString) => dispatch => {
  const url = BaseCoreURL + PHONETIC_CITY_SEARCH + searchString + '?is_phonetic=true';
  genericGetCall(url)
    .then(res => {
      if (res && res.status === 200) {
        dispatch({
          type: PAYTM_CITY_SEARCH_DATA,
          payload: { data: res.data || [] },
        })
      } else {
        alert('Error, Please try again.');
      }
    })
}

const genericGetCall = (url, query = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  return axios
    .get(url, { headers, params: query })
    .then(response => response)
    .catch(error => {
      return error
    })
}
